module.exports = __webpack_public_path__ + "static/ristretto@2x-61be213ef8cf26d0b663509519d5bb7d.png";